/* eslint-disable no-warning-comments */

import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { UserCircleIcon } from "@heroicons/react/24/solid";

const ReportHeader = ({ headerText, showMenu }) => (
	<Container className="profile-page-top-header align-items-center d-flex flex-wrap justify-content-between px-0 mb-3">
		<Button className="nav-menu-button" onClick={showMenu}>Menu</Button>
		<h1 className="fs-32 mb-0">{headerText}</h1>
		<NavLink className="d-flex align-items-center" to="/profile/account">
			<UserCircleIcon className="me-1" height={20} width={20} /> My Account
		</NavLink>
	</Container>
);

ReportHeader.propTypes = {
	headerText: PropTypes.string,
	showMenu: PropTypes.func,
};

ReportHeader.defaultProps = {
	headerText: "Your EQQO Report",
	showMenu: null
}

export default ReportHeader;
